'use client';

import React from 'react';
import ContactHero from './ContactHero';
import ContactMethodCard from './ContactMethodCard';

import TrustSection from './TrustSection';

interface ContactMethod {
  id: string;
  icon: string;
  title: string;
  description: string;
  value: string;
  action: string;
  actionLink: string;
  available: string;
}

interface Facility {
  id: string;
  name: string;
  address: string;
  city: string;
  pincode: string;
  phone: string;
  whatsapp: string;
  email: string;
  image: string;
  alt: string;
  latitude: number;
  longitude: number;
  features: string[];
  parking: string;
  accessibility: string;
  publicTransport: string;
}

const ContactInteractive = () => {
  const contactMethods = [
  {
    icon: 'ChatBubbleLeftRightIcon',
    title: 'WhatsApp Business',
    description: 'Quick responses for immediate inquiries and booking assistance',
    value: '+91 98710 10610',
    action: 'Chat Now',
    actionLink: 'https://wa.me/919871010610',
    available: 'Available 24/7'
  },
  {
    icon: 'PhoneIcon',
    title: 'Phone Support',
    description: 'Speak directly with our team for detailed program information',
    value: '+91 98710 10610',
    action: 'Call Now',
    actionLink: 'tel:+919871010610',
    available: 'Mon-Sat: 9:00 AM - 8:00 PM'
  },
  {
    icon: 'EnvelopeIcon',
    title: 'Email Support',
    description: 'Detailed inquiries and program documentation requests',
    value: 'sprintacademygospeed@gmail.com',
    action: 'Send Email',
    actionLink: 'mailto:sprintacademygospeed@gmail.com',
    available: 'Response within 24 hours'
  }];


  const facilities = [
  {
    id: '1',
    name: 'GO Speed Academy - Main Campus',
    address: 'DPS RKPuram, Vasant Kunj, New Delhi, 110022',
    city: 'New Delhi',
    pincode: '110022',
    phone: '+91 98710 10610',
    whatsapp: '+91 98710 10610',
    email: 'sprintacademygospeed@gmail.com',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b9cf2b3f-1766499443104.png",
    alt: 'Modern sports training facility with professional equipment and spacious training area',
    latitude: 19.0760,
    longitude: 72.8777,
    features: [
    'Olympic-grade track',
    'Strength training zone',
    'Indoor training hall',
    'Recovery center',
    'Nutrition consultation',
    'Video analysis room'],

    parking: 'Free parking for 50+ vehicles with covered area',
    accessibility: 'Wheelchair accessible with ramps and elevators',
    publicTransport: 'Metro station 500m away, multiple bus routes available'
  },
  {
    id: '2',
    name: 'GO Speed Academy - North Branch',
    address: '456 Fitness Avenue, Andheri West',
    city: 'Mumbai',
    pincode: '400053',
    phone: '+91 81308 28282',
    whatsapp: '+91 81308 28282',
    email: 'sprintacademygospeed@gmail.com',
    image: "https://images.unsplash.com/photo-1685633224860-7655234d9cd5",
    alt: 'Professional gym interior with modern cardio equipment and weight training area',
    latitude: 19.1136,
    longitude: 72.8697,
    features: [
    'Cardio equipment zone',
    'Free weights area',
    'Group training space',
    'Kids play area',
    'Locker facilities',
    'Refreshment counter'],

    parking: 'Valet parking service available',
    accessibility: 'Ground floor access with wide doorways',
    publicTransport: 'Railway station 1km away, auto-rickshaw stand nearby'
  }];


  return (
    <div className="min-h-screen bg-background">
      <ContactHero />

      <section className="py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 lg:mb-16">
            <h2 className="text-3xl lg:text-4xl xl:text-5xl font-heading font-bold text-primary mb-4">
              Choose Your Preferred Contact Method
            </h2>
            <p className="text-base lg:text-lg text-text-secondary max-w-3xl mx-auto">
              We offer multiple ways to connect with us. Select the method that works best for you
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {contactMethods.map((method) =>
            <ContactMethodCard key={method.id} method={method} />
            )}
          </div>
        </div>
      </section>

      <TrustSection />
    </div>);

};

export default ContactInteractive;